import { render, staticRenderFns } from "./TradingRecord.vue?vue&type=template&id=8fcb226c&"
import script from "./TradingRecord.vue?vue&type=script&lang=js&"
export * from "./TradingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports